import { Button, Header, LoadingSpinner, OtpInput } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { useInterval } from 'usehooks-ts'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'
import { useKeyboardAwareViewport } from '@/hooks/useKeyboardAwareViewport'
import '@/components/Generic/OtpInput/OtpInput.css'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

const DELAY = 8000

export const OtpPage = observer(() => {
  const viewport = useKeyboardAwareViewport()

  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { currentScenarioId } = store.ScenarioState
  const { otpPage: trans } = store.TranslationsState.translations

  const [otpValue, setOtpValue] = useState('')
  const [pageStatus, setPageStatus] = useState('code')
  const [verified, setVerified] = useState(false)
  const [testsCounter, setTestsCounter] = useState(10)

  const handlePooling = async () => {
    try {
      if (currentScenarioId !== 'localTests') {
        const res = await axiosInstance.post(
          `${API_URL}/${ONBOARDING_SERVICE_PATH}/proceed-signature`,
          {},
          {
            withCredentials: true,
          }
        )

        if (res.data && res.data.status) {
          const { status } = res.data
          if (status === 'success') {
            setVerified(true)
            currentScenarioId !== 'localTests' && handleSendCode()
            setPageStatus('code')
          }
        }
      } else {
        if (testsCounter !== 0) {
          setTestsCounter(testsCounter - 1)
        } else {
          setVerified(true)
          setPageStatus('code')
        }
      }
    } catch (e) {
      devLog(e)
    }
  }

  const handleProceed = async () => {
    try {
      if (pageStatus === 'code') {
        if (currentScenarioId !== 'localTests') {
          await axiosInstance.post(
            `${API_URL}/electronic-id/sign`,
            {
              challenge_code: otpValue,
            },
            {
              withCredentials: true,
            }
          )
        }

        store.ScenarioState.nextPage()
      } else if (pageStatus === 'verifying') {
        setPageStatus('code')
        currentScenarioId !== 'localTests' && handleSendCode()
      }
    } catch (e) {
      devLog(e)
    }
  }

  const handleSendCode = async () => {
    try {
      await axiosInstance.post(
        `${API_URL}/electronic-id/request-signature`,
        {},
        {
          withCredentials: true,
        }
      )
    } catch (e) {
      devLog(e)
    }
  }

  useInterval(
    () => {
      pageStatus === 'verifying' && handlePooling()
    },
    !verified ? DELAY : null
  )

  return (
    <div className="page-container">
      {pageStatus === 'code' && (
        <>
          <Header className="m-20-0-0">{trans.header}</Header>
          <OtpInput
            value={otpValue}
            valueLength={6}
            onChange={(value) => setOtpValue(value)}
            className="otp-input__container--full-width otp-input__container--mt-20"
          />
        </>
      )}
      {pageStatus === 'verifying' && (
        <>
          <h2>{trans.headerVerifying}</h2>
          <LoadingSpinner />
          <div className="layout__content-container-bottom-fixed">
            {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
            <Button disabled={true}>{trans.verify}</Button>
          </div>
        </>
      )}
      <div
        className="layout__content-container-bottom-fixed"
        style={
          viewport?.keyboardHeight
            ? { top: 'unset', bottom: `${viewport.keyboardHeight}px` }
            : undefined
        }
      >
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
        <Button onClick={() => handleProceed()}>
          <span className="generic__button-text">{trans.verify}</span>
        </Button>
      </div>
    </div>
  )
})
